import produce from 'immer';
import { handleActions } from 'redux-actions';
import { v4 as uuidv4 } from 'uuid';

import dayjs from '@/libs/dayjs';

const initialState = [];

export default handleActions(
  {
    'NOTIFICATIONS/RESET': (state, action) => initialState,
    'NOTIFICATIONS/ADD': (state, action) =>
      produce(state, (draft) => {
        const { robotId, text } = action.payload;

        const notification = {
          id: uuidv4(),
          robotId,
          text,
          time: dayjs().format('HH:mm:ss'),
        };

        draft.unshift(notification);
      }),
    'NOTIFICATIONS/REMOVE': (state, action) => {
      const { robotId } = action.payload;

      return state.filter((notification) => notification.robotId !== robotId);
    },
  },
  initialState,
);
